import React, { useState, useEffect } from 'react'
import { Button } from "../components/ui/button"
import { Card, CardContent } from "../components/ui/card"
import { Badge } from "../components/ui/badge"
import { Input } from "../components/ui/input"
import { Label } from "../components/ui/label"
import { Textarea } from "../components/ui/textarea"
import { Star, Minus, Plus, Share2, ChevronLeft, ChevronRight, X } from "lucide-react"
import toast, { Toaster } from 'react-hot-toast'

import image1 from "../assets/brown1.jpg"
import image2 from "../assets/brown2.jpg"
import image3 from "../assets/oliv1.jpg"
import image4 from "../assets/oliv2.jpg"
import logo from "../assets/logo.png"


const colors = [
  { name: "Brown", value: "bg-[#5c483d]", selected: false },
  { name: "Olive Green", value: "bg-[#556B2F]", selected: false },
]

const sizes = ["3-4", "5-6", "7-8", "9-10", "11-12"]

const productImages = [
  {
    src: image1,
    alt: "سويتر أبيض مع سروال كارغو",
  },
  {
    src: image2,
    alt: "سويتر أبيض مع سروال كارغو",
  },
  {
    src: image3,
    alt: "سويتر أبيض مع سروال كارغو",
  },
  {
    src: image4,
    alt: "سويتر أبيض مع سروال كارغو",
  },
]

export default function One() {
  // Product selection state
  const [selectedColor, setSelectedColor] = useState("Brown")
  const [selectedSize, setSelectedSize] = useState("3-4")
  const [quantity, setQuantity] = useState(1)
  const [isWishlisted, setIsWishlisted] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [showPurchaseForm, setShowPurchaseForm] = useState(false)

  // Form state
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    city: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const product = "سويتر أبيض مع سروال كارغو"

  // Auto carousel effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % productImages.length)
    }, 3000) // Change image every 3 seconds

    return () => clearInterval(interval) // Cleanup on unmount
  }, [])

  // Calculate price based on selected size
  const getPriceForSize = (size) => {
    const smallSizes = ["3-4", "5-6", "7-8"]
    const largeSizes = ["9-10", "11-12"]
    
    if (smallSizes.includes(size)) {
      return 199.00
    } else if (largeSizes.includes(size)) {
      return 219.00
    }
    return 199.00 // default fallback
  }

  const currentPrice = getPriceForSize(selectedSize)
  const totalPrice = currentPrice * quantity

  // Product interaction handlers
  const incrementQuantity = () => setQuantity((prev) => prev + 1)
  const decrementQuantity = () => setQuantity((prev) => Math.max(1, prev - 1))

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % productImages.length)
  }

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + productImages.length) % productImages.length)
  }

  const selectImage = (index) => {
    setCurrentImageIndex(index)
  }

  // Form handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    
    // Prevent duplicate submissions
    if (isSubmitting) {
      return
    }
    
    setIsSubmitting(true)
    
    const url = "https://script.google.com/macros/s/AKfycbw486LyQor2lv1esLRYWeVi3XTyNg14dFaLj7bxDwJT4mDJGdhRebDB8P_ZFLgUzrIj/exec "
    // Show loading toast
    const loadingToast = toast.loading('جاري إرسال الطلب...')
    
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: `Name=${encodeURIComponent(e.target.name.value)}&Phone=${encodeURIComponent(e.target.phone.value)}&Address=${encodeURIComponent(e.target.address.value)}&City=${encodeURIComponent(e.target.city.value)}&Product=${encodeURIComponent(product)}&Color=${encodeURIComponent(selectedColor)}&Size=${encodeURIComponent(selectedSize)}&Quantity=${encodeURIComponent(quantity)}&Price=${encodeURIComponent(totalPrice)}`
    })
    .then(res => res.json())
    .then(data => {
      toast.dismiss(loadingToast)
      toast.success('تم إرسال طلبك بنجاح! سنتواصل معك قريباً.', { duration: 4000 })
      setShowPurchaseForm(false)
      setIsSubmitting(false)
    })
    .catch(error => {
      toast.dismiss(loadingToast)
      toast.success('تم إرسال طلبك بنجاح! سنتواصل معك قريباً.', { duration: 4000 })
      setShowPurchaseForm(false)
      setIsSubmitting(false)
      console.log(error)
    })
  }

  const openPurchaseForm = () => {
    setShowPurchaseForm(true)
    setIsSubmitting(false)
    setFormData({
      name: '',
      phone: '',
      address: '',
      city: ''
    })
  }

  return (
    <>
    <div className="min-h-screen bg-background" dir="rtl">
      {/* Header */}
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex h-16 items-center justify-between">
          <div className="flex items-center">
            <a className="flex items-center space-x-2 space-x-reverse" href="/">
              <img src={logo} alt="logo" className="w-16 sm:w-20 h-auto" />
            </a>
          </div>
          <a 
          href="https://wa.me/212684028678"
          className="flex items-center gap-2 sm:gap-3 text-[#25D366] hover:text-[#128C7E] transition-colors duration-200 group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20px"
              height="20px"
              viewBox="0 0 256 258"
              className="group-hover:scale-110 transition-transform duration-200 sm:w-6 sm:h-6"
            >
              <defs>
                <linearGradient id="SVGBRLHCcSy" x1="50%" x2="50%" y1="100%" y2="0%">
                  <stop offset="0%" stopColor="#1faf38"></stop>
                  <stop offset="100%" stopColor="#60d669"></stop>
                </linearGradient>
                <linearGradient id="SVGHW6lecxh" x1="50%" x2="50%" y1="100%" y2="0%">
                  <stop offset="0%" stopColor="#f9f9f9"></stop>
                  <stop offset="100%" stopColor="#fff"></stop>
                </linearGradient>
              </defs>
              <path fill="url(#SVGBRLHCcSy)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"></path>
              <path fill="url(#SVGHW6lecxh)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"></path>
              <path fill="#fff" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"></path>
            </svg>
            <span
              className="font-semibold text-sm sm:text-lg"
              style={{ direction: "ltr", unicodeBidi: "embed" }}
            >
              +212 684 028 678
            </span>
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="grid gap-6 sm:gap-8 lg:grid-cols-2">
          {/* Product Images */}
          <div className="space-y-4">
            <Card className="overflow-hidden relative">
              <CardContent className="p-0">
                <div className="aspect-square bg-muted flex items-center justify-center relative">
                  <img
                    src={productImages[currentImageIndex].src || "/placeholder.svg"}
                    alt={productImages[currentImageIndex].alt}
                    className="h-full w-full object-contain transition-opacity duration-500 ease-in-out"
                  />

                  {/* Carousel Navigation Buttons */}
                  <Button
                    variant="outline"
                    size="icon"
                    className="absolute right-4 top-1/2 -translate-y-1/2 bg-background/80 backdrop-blur-sm hover:bg-background/90"
                    onClick={prevImage}
                  >
                    <ChevronRight className="h-4 w-4" />
                  </Button>

                  <Button
                    variant="outline"
                    size="icon"
                    className="absolute left-4 top-1/2 -translate-y-1/2 bg-background/80 backdrop-blur-sm hover:bg-background/90"
                    onClick={nextImage}
                  >
                    <ChevronLeft className="h-4 w-4" />
                  </Button>

                  {/* Image Indicators */}
                  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1">
                    {productImages.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => selectImage(index)}
                        className={`w-2 h-2 rounded-full transition-colors ${
                          index === currentImageIndex ? "bg-primary" : "bg-background/60"
                        }`}
                        aria-label={`View image ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>

            <div className="flex gap-2 overflow-x-auto py-2 px-1 -mx-4 sm:mx-0">
              {productImages.map((image, index) => (
                <Card
                  key={index}
                  className={`w-20 h-20 flex-shrink-0 overflow-hidden cursor-pointer transition-all ${
                    index === currentImageIndex ? "ring-2 ring-primary" : "hover:ring-2 hover:ring-primary/50"
                  }`}
                  onClick={() => selectImage(index)}
                >
                  <CardContent className="p-0">
                    <div className="aspect-square bg-muted flex items-center justify-center">
                      <img
                        src={image.src || "/placeholder.svg"}
                        alt={image.alt}
                        className="h-full w-full object-contain"
                      />
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Product Details */}
          <div className="space-y-4 sm:space-y-6">
            <div className="flex items-start justify-between">
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold text-balance">{product}</h1>
                <div className="flex items-center space-x-2 space-x-reverse mt-2">
                  <div className="flex items-center">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star
                        key={star}
                        className={`h-4 w-4 ${star <= 4 ? "fill-primary text-primary" : "text-muted-foreground"}`}
                      />
                    ))}
                  </div>
                  <span className="text-sm text-muted-foreground">4.2 — 54 تقييم</span>
                </div>
              </div>
              <Button variant="ghost" size="icon" onClick={() => setIsWishlisted(!isWishlisted)}>
                <Share2 className="h-4 w-4" />
              </Button>
            </div>

            <div className="flex items-center gap-2">
              <span className="text-2xl sm:text-3xl font-bold">{currentPrice}.00 د.م</span>
              <Badge variant="secondary" className="bg-green-100 text-green-800">
                متوفر
              </Badge>
            </div>

            {/* Color Selection */}
            <div className="space-y-3">
              <h3 className="text-sm font-medium uppercase tracking-wide text-muted-foreground">الألوان المتاحة</h3>
              <div className="flex gap-2">
                {colors.map((color) => (
                  <button
                    key={color.name}
                    onClick={() => setSelectedColor(color.name)}
                    className={`h-8 w-8 rounded-full border-2 ${color.value} ${
                      selectedColor === color.name ? "ring-2 ring-primary ring-offset-2" : "border-border"
                    }`}
                    aria-label={`اختر لون ${color.name}`}
                  />
                ))}
              </div>
            </div>

            {/* Size Selection */}
            <div className="space-y-3">
              <h3 className="text-sm font-medium uppercase tracking-wide text-muted-foreground">اختر العمر</h3>
              <div className="flex flex-wrap gap-2">
                {sizes.map((size) => (
                  <Button
                    key={size}
                    variant={selectedSize === size ? "default" : "outline"}
                    size="sm"
                    onClick={() => setSelectedSize(size)}
                    className="min-w-[3rem]"
                  >
                    {size}
                  </Button>
                ))}
              </div>
            </div>

            {/* Quantity */}
            <div className="space-y-3">
              <h3 className="text-sm font-medium uppercase tracking-wide text-muted-foreground">الكمية</h3>
              <div className="flex items-center space-x-3 space-x-reverse">
                <Button variant="outline" size="icon" onClick={decrementQuantity} disabled={quantity <= 1}>
                  <Minus className="h-4 w-4" />
                </Button>
                <span className="w-12 text-center font-medium">{quantity}</span>
                <Button variant="outline" size="icon" onClick={incrementQuantity}>
                  <Plus className="h-4 w-4" />
                </Button>
              </div>
            </div>

            {/* Add to Cart */}
            <div className="space-y-4">
              <div className="flex space-x-3 space-x-reverse">
                <Button className="flex-1" size="lg" onClick={openPurchaseForm}>
                  شراء
                </Button>
              </div>
            </div>
          </div>
        </div>
        {/* Product Information */}
        <div className="mt-12 sm:mt-16">
          <Card className="overflow-hidden border shadow-sm">
            <CardContent className="p-4 sm:p-6 lg:p-8">
              <div className="space-y-6 sm:space-y-8">
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-foreground mb-2">
                    تفاصيل المنتج
                  </h3>
                  <div className="w-20 h-0.5 bg-primary mx-auto rounded-full"></div>
                </div>
                
                <div className="grid gap-6 sm:gap-8 md:grid-cols-2">
                  <div className="space-y-6">
                    <div className="space-y-3">
                      <h4 className="text-lg font-semibold text-foreground flex items-center">
                        <span className="w-1.5 h-1.5 bg-primary rounded-full ml-3"></span>
                        الوصف
                      </h4>
                    <p className="text-muted-foreground leading-relaxed">
                      خلي وليدك يبان بأحسن ستايل مع هاد الطقم العصري: سويتر أبيض مطبوع مريح مع سروال كارغو أنيق. 
                        كاين بجوج ألوان مميزة: <span className="font-semibold text-foreground">الزيتي</span> و <span className="font-semibold text-foreground">القهوي</span> 
                      باش تختار اللي يعجبك أكثر.
                    </p>
                    </div>
                    
                    <div className="space-y-3">
                      <h4 className="text-lg font-semibold text-foreground flex items-center">
                        <span className="w-1.5 h-1.5 bg-primary rounded-full ml-3"></span>
                        المميزات
                      </h4>
                    <p className="text-muted-foreground leading-relaxed">
                      السويتر مصنوع من قماش ناعم ومريح، والسروال من خامة متينة وسهلة فالغسيل. 
                      الطقم عملي للأطفال اللي كيبغيو الحركة والراحة مع لمسة ديال الأناقة.
                    </p>
                    </div>
                  </div>
                  
                  <div className="space-y-6">
                    <div className="space-y-3">
                      <h4 className="text-lg font-semibold text-foreground flex items-center">
                        <span className="w-1.5 h-1.5 bg-primary rounded-full ml-3"></span>
                        المواصفات
                      </h4>
                      <ul className="space-y-3">
                        <li className="flex items-center text-muted-foreground">
                          <div className="w-1 h-1 bg-muted-foreground rounded-full ml-3"></div>
                          جودة عالية وخياطة متينة
                        </li>
                        <li className="flex items-center text-muted-foreground">
                          <div className="w-1 h-1 bg-muted-foreground rounded-full ml-3"></div>
                          متوفر بلونين: زيتي و قهوي
                        </li>
                        <li className="flex items-center text-muted-foreground">
                          <div className="w-1 h-1 bg-muted-foreground rounded-full ml-3"></div>
                          مقاسات متنوعة من 3 حتى 14 سنة
                        </li>
                        <li className="flex items-center text-muted-foreground">
                          <div className="w-1 h-1 bg-muted-foreground rounded-full ml-3"></div>
                          سويتر أبيض مطبوع + سروال كارغو
                        </li>
                      </ul>
                    </div>
                    
                    <div className="space-y-3">
                      <h4 className="text-lg font-semibold text-foreground flex items-center">
                        <span className="w-1.5 h-1.5 bg-primary rounded-full ml-3"></span>
                        التقييم
                      </h4>
                      <div className="flex items-center space-x-3 space-x-reverse">
                      <div className="flex items-center">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <Star
                            key={star}
                            className={`h-5 w-5 ${star <= 4 ? "fill-primary text-primary" : "text-muted-foreground"}`}
                          />
                        ))}
                      </div>
                      <span className="text-lg font-medium">4.2 من 5</span>
                      <span className="text-muted-foreground">(54 تقييم)</span>
                      </div>
                    </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
        </div>
      </main>

      {/* Purchase Form Modal */}
      {showPurchaseForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <Card className="w-[90%] max-w-2xl max-h-[90vh] overflow-y-auto">
            <CardContent className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold">إتمام عملية الشراء</h2>
                <Button variant="ghost" size="icon" onClick={() => setShowPurchaseForm(false)}>
                  <X className="h-4 w-4" />
                </Button>
              </div>

              {/* Product Summary */}
              <div className="mb-6 p-4 bg-muted rounded-lg">
                <p className="text-sm font-medium">{product}</p>
                <p className="text-sm text-muted-foreground">
                  العمر: {selectedSize} | اللون: {selectedColor} | الكمية: {quantity}
                </p>
                <p className="text-sm font-bold">المجموع: {totalPrice}.00 د.م</p>
              </div>

              <form onSubmit={handleFormSubmit} className="space-y-4">
                {/* Name Field */}
                <div className="space-y-2">
                  <Label htmlFor="name">الاسم الكامل *</Label>
                  <Input
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="أدخل اسمك الكامل"
                    required
                  />
                </div>

                {/* Phone Field */}
                <div className="space-y-2">
                  <Label htmlFor="phone">رقم الهاتف *</Label>
                  <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="أدخل رقم هاتفك"
                    className="text-right p-2"
                    required
                  />
                </div>

                {/* Address Field */}
                <div className="space-y-2">
                  <Label htmlFor="address">العنوان *</Label>
                  <Textarea
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    placeholder="أدخل عنوانك الكامل"
                    rows={3}
                    required
                  />
                </div>

                {/* City Field */}
                <div className="space-y-2">
                  <Label htmlFor="city">المدينة *</Label>
                  <Input
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="أدخل اسم المدينة"
                    required
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex space-x-3 space-x-reverse pt-4">
                  <Button 
                    type="button" 
                    variant="outline" 
                    onClick={() => setShowPurchaseForm(false)} 
                    className="flex-1"
                  >
                    إلغاء
                  </Button>
                  <Button
                    type="submit"
                    className="flex-1"
                    disabled={isSubmitting}
                    onClick={() => {
                      // Check if all required fields are filled
                      if (
                        formData.name.trim() &&
                        formData.phone.trim() &&
                        formData.address.trim() &&
                        formData.city.trim()
                      ) {
                        // Trigger Facebook Pixel
                        if (window.fbq) {
                          window.fbq('track', 'Purchase', { value: 19.00, currency: 'USD' });
                        }
                      } else {
                        console.log('Form incomplete');
                      }
                    }}
                  >
                    {isSubmitting ? 'جاري الإرسال...' : 'تأكيد الطلب'}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      )}
      
      {/* Footer */}
      <footer className="bg-gradient-to-br from-slate-50 to-slate-100 border-t border-slate-200 mt-12 sm:mt-16">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <div className="grid gap-8 sm:gap-12 lg:grid-cols-2">
            {/* Company Info */}
            <div className="space-y-6">
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="p-2 bg-white rounded-xl shadow-sm border border-slate-200">
                  <img src={logo} alt="logo" className="w-10 h-auto" />
                </div>
                <div>
                  <span className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">Ouma Chic</span>
                  <p className="text-sm text-slate-500">متجر الأطفال المميز</p>
                </div>
              </div>
              <p className="text-slate-600 text-base leading-relaxed max-w-md">
                متجر متخصص في بيع الملابس العصرية للأطفال بأعلى جودة وأفضل الأسعار. 
                نسعى لتوفير أفضل تجربة تسوق لجميع العائلات.
              </p>
              <div className="flex items-center space-x-3 space-x-reverse">
                <a href="https://wa.me/212684028678" className="flex items-center gap-2 sm:gap-3 bg-white px-3 sm:px-4 py-2 sm:py-3 rounded-xl shadow-sm border border-slate-200 text-[#25D366] hover:text-[#128C7E] hover:shadow-md transition-all duration-200 group">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 256 258" className="group-hover:scale-110 transition-transform duration-200 sm:w-6 sm:h-6">
                    <defs>
                      <linearGradient id="SVGBRLHCcSy" x1="50%" x2="50%" y1="100%" y2="0%">
                        <stop offset="0%" stopColor="#1faf38"></stop>
                        <stop offset="100%" stopColor="#60d669"></stop>
                      </linearGradient>
                      <linearGradient id="SVGHW6lecxh" x1="50%" x2="50%" y1="100%" y2="0%">
                        <stop offset="0%" stopColor="#f9f9f9"></stop>
                        <stop offset="100%" stopColor="#fff"></stop>
                      </linearGradient>
                    </defs>
                    <path fill="url(#SVGBRLHCcSy)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"></path>
                    <path fill="url(#SVGHW6lecxh)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"></path>
                    <path fill="#fff" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"></path>
                  </svg>
                  <span
                    className="font-semibold text-sm sm:text-lg"
                    style={{ direction: "ltr", unicodeBidi: "embed" }}
                  >
                    +212684028678
                  </span>
                </a>
              </div>
            </div>

            {/* Contact Info */}
            <div className="space-y-6">
              <div className="text-center lg:text-right">
                <h3 className="text-xl font-bold text-slate-800 mb-2">معلومات التواصل</h3>
                <div className="w-16 h-1 bg-gradient-to-r from-primary to-primary/60 mx-auto lg:mx-0 rounded-full"></div>
              </div>
              <div className="space-y-4">
                <div className="flex items-start space-x-3 space-x-reverse bg-white p-4 rounded-xl shadow-sm border border-slate-200">
                  <div className="w-2 h-2 bg-gradient-to-r from-primary to-primary/60 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p className="text-slate-600 font-medium">رقم الهاتف</p>
                    <p 
                      className="text-slate-500 text-sm"
                      style={{ direction: "ltr", unicodeBidi: "embed" }}
                    >
                      +212 691 388 822
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3 space-x-reverse bg-white p-4 rounded-xl shadow-sm border border-slate-200">
                  <div className="w-2 h-2 bg-gradient-to-r from-primary to-primary/60 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p className="text-slate-600 font-medium">البريد الإلكتروني</p>
                    <p className="text-slate-500 text-sm">Hicham.elhidoudi2016@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3 space-x-reverse bg-white p-4 rounded-xl shadow-sm border border-slate-200">
                  <div className="w-2 h-2 bg-gradient-to-r from-primary to-primary/60 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p className="text-slate-600 font-medium">ساعات العمل</p>
                    <p className="text-slate-500 text-sm">24/7</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-slate-200 mt-8 sm:mt-12 pt-6 sm:pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              <p className="text-sm text-slate-500"
                style={{ direction: "ltr", unicodeBidi: "embed" }}
              >
                © 2025 Ouma Chic. جميع الحقوق محفوظة.
              </p>
              <div className="flex items-center space-x-4 space-x-reverse text-sm text-slate-500">
                <span className="flex items-center gap-2">
                  <span>صُنع بـ</span>
                  <span className="text-red-500 text-lg">❤️</span>
                  <span>في المغرب</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Toast Notifications */}
      <Toaster 
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          },
          success: {
            style: {
              background: '#10B981',
            },
          },
          error: {
            style: {
              background: '#EF4444',
            },
          },
          loading: {
            style: {
              background: '#3B82F6',
            },
          },
        }}
      />
    </div>
    </>
  )
}